import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "pq_content"
};
import { ElMessage } from 'element-plus';
import { getUsers } from '../../utils/lc';
import { getCurrentInstance, ref, reactive, watch, useAttrs } from 'vue';
/* 数据层 */

export default {
  __name: 'lcDailogrybg',
  props: ['ids', 'rybgshow', 'reviewerUserId'],
  emits: ['update:rybgshow'],
  setup(__props, {
    emit: __emit
  }) {
    const {
      proxy
    } = getCurrentInstance();
    let data = reactive({
      userlist: [],
      userSet: {
        page: 1,
        size: 9999999,
        nickname: ''
      }
    });
    const props = __props;
    let thereviewerUserId = ref(props.reviewerUserId ? JSON.parse(JSON.stringify(props.reviewerUserId)) : '');
    const attrs = useAttrs();
    /* 初始化 */
    getUsers(data.userSet).then(res => {
      data.userlist = JSON.parse(JSON.stringify(res.data));
    });
    /* 方法 */
    const emits = __emit;
    // 远程搜索人
    function userremoteMethod(value) {
      proxy.$http.showLoading(false).get('project/data/user', {
        nickname: value,
        page: 1,
        size: 99999
      }).then(res => {
        data.userlist = res.data.data;
      });
    }
    // 确认
    function makeSure() {
      if (props.ids) {
        proxy.$http.showLoading(false).get('project/task/ch_user', {
          ids: props.ids,
          type: 'reviewer_user',
          user_id: thereviewerUserId.value
        }).then(res => {
          // 刷新爷组件详情数据接口
          if (res.errno == 200) {
            attrs.deppgetPageInfo();
            ElMessage({
              type: 'success',
              message: '操作成功'
            });
          } else {
            ElMessage({
              type: 'error',
              message: res.errmsg
            });
          }
        });
      }
      emits('update:rybgshow', false);
    }
    //关闭的点击事件
    function handleClose() {
      emits('update:rybgshow', false);
    }
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
        title: "审核人",
        "model-value": __props.rybgshow,
        width: "320px",
        "before-close": handleClose,
        center: false
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_cache[1] || (_cache[1] = _createElementVNode("label", null, "任务审核人", -1)), _createVNode(_component_el_select, {
          modelValue: _unref(thereviewerUserId),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(thereviewerUserId) ? thereviewerUserId.value = $event : thereviewerUserId = $event),
          placeholder: "请选择",
          filterable: "",
          remote: "",
          "remote-method": userremoteMethod
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).userlist, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.nickname,
              value: item.id
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("div", {
          class: "pq_content",
          style: {
            "justify-content": "right",
            "margin-top": "15px"
          }
        }, [_createElementVNode("div", {
          class: "l-button pqbt",
          onClick: handleClose
        }, "取消"), _createElementVNode("div", {
          class: "l-button",
          style: {
            "margin-right": "0",
            "margin-left": "15px"
          },
          onClick: makeSure
        }, "确认")])]),
        _: 1
      }, 8, ["model-value"])]);
    };
  }
};